import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PicturesFilterComponent } from './pictures-filter.component';
import { FormFieldModule } from '../form-field';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MultiselectWithSearchModule } from '@shared/components';
import { ParametersModule } from '@games/core/parameters/parameters.module';
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@NgModule({
  declarations: [PicturesFilterComponent],
  imports: [
    CommonModule,
    FormFieldModule,
    NgSelectModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MultiselectWithSearchModule,
    ParametersModule,
    MatProgressSpinner,
  ],
  exports: [PicturesFilterComponent],
})
export class PicturesFilterModule {}
